export const addOfferModal = {
  namespaced: true,
  state: {
    show: false,
    data: null,
  },
  mutations: {
    open(state, data) {
      state.data = data;
      state.show = true;
    },
    close(state) {
      state.show = false;
      state.data = null;
    },
  },
  actions: {
    open({ commit }, data) {
      commit("open", data);
    },
    close({ commit }) {
      commit("close");
    },
  },
};
